import styled, { css } from 'styled-components'

import { Chip } from '@/components/business/market-shop/chip'
import { Icon } from '@/components/ui/icon'

export const ProductCardContainer = styled.div<{ $isOutOfStock: boolean }>(
  ({ theme, $isOutOfStock }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: ${theme.colors.gray300};
    border: ${theme.border.size['1']} solid ${theme.colors.gray300};
    border-radius: ${theme.border.radius['12']};
    opacity: ${$isOutOfStock ? 0.5 : 1};
  `,
)

export const OutOfStockChip = styled(Chip)(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space['8']};
    right: ${theme.space['12']};
  `,
)

export const TagsColumn = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space['8']};
    left: ${theme.space['12']};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.space['4']};
  `,
)

export const ImageContainer = styled.div(
  () => css`
    display: grid;
    place-content: center;
    aspect-ratio: 1 / 1;
    width: 100%;
    height: 100%;
    flex: 0;
    cursor: pointer;
  `,
)

export const Image = styled.img(
  () => css`
    aspect-ratio: 1 / 1;
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  `,
)

export const PlaceholderImage = styled(Icon)(
  ({ theme }) => css`
    display: flex;
    color: ${theme.colors.gray600};
  `,
)

export const Content = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['8']};
    background-color: ${theme.colors.white};
  `,
)

export const Title = styled.span(
  ({ theme }) => css`
    margin-bottom: ${theme.space['2']};
    cursor: pointer;
  `,
)

export const Description = styled.span(
  ({ theme }) => css`
    margin-bottom: ${theme.space['10']};
  `,
)

export const Controls = styled.div(
  () => css`
    display: flex;
    align-items: center;
    margin-top: auto;
    min-height: 4.4rem;
  `,
)

export const PriceGroup = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    margin-right: auto;
  `,
)

export const OriginalPrice = styled.span(
  ({ theme }) => css`
    text-decoration: line-through;
    color: ${theme.colors.black300};
  `,
)

export const Count = styled.span(
  ({ theme }) => css`
    min-width: 1.6rem;
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['2']};
  `,
)
